<template>
  <div class="content">
    <div class="logo">
      <img src="../../img/pc/logo.png" />
    </div>
    <div class="banner">
      <img src="../../img/pc/banner.png" />
    </div>
    <p class="title">立即下载</p>
    <div class="downLoadWay">
      <div class="download" @mouseover="hover(0)" @mouseout="out(0)">
        <div class="android1" :style="{'display':flag0 === 0? 'block' : 'none'}">
          <img src="../../img/pc/Android.png" />
          <p class="nameWay">Android</p>
        </div>
        <div class="android2" :style="{'display':flag0 === 1? 'block' : 'none'}">
          <img src="../../img/pc/qrCode.png" />
          <p class="nameWay1">扫描二维码</p>
          <p class="nameWay1" style="position:relative;top:152px;">下载Android客户端</p>
        </div>
      </div>
      <div class="download" @mouseover="hover(1)" @mouseout="out(1)">
        <div class="iphone1" :style="{'display':flag1 === 0? 'block' : 'none'}">
          <img src="../../img/pc/iPhone.png" />
          <p class="nameWay">iphone</p>
        </div>
        <div class="iphone2" :style="{'display':flag1 === 1? 'block' : 'none'}">
          <img src="../../img/pc/qrCode.png" />
          <p class="nameWay1">扫描二维码</p>
          <p class="nameWay1" style="position:relative;top:152px;">下载iPhone客户端</p>
        </div>
      </div>
      <div class="download" @mouseover="hover(2)" @mouseout="out(2)">
        <div class="mac1" :style="{'display':flag2 === 0? 'block' : 'none'}">
          <img src="../../img/pc/Mac.png" />
          <p class="nameWay">Mac桌面版</p>
        </div>
        <div class="mac2" :style="{'display':flag2 === 1? 'block' : 'none'}" @click.stop="downloadMac()">
          <img src="../../img/pc/download.png" />
          <p class="nameWay2">下载Mac客户端</p>
        </div>
      </div>
      <div class="download" @mouseover="hover(3)" @mouseout="out(3)">
        <div class="windows1" :style="{'display':flag3 === 0? 'block' : 'none'}">
          <img src="../../img/pc/Windows.png" />
          <p class="nameWay">Windows</p>
        </div>
        <div
          class="windows2"
          :style="{'display':flag3 === 1? 'block' : 'none'}"
          @click.stop="downloadWin()"
        >
          <img src="../../img/pc/download.png" />
          <p class="nameWay2">点击下载Windows客户端</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag0: 0,
      flag1: 0,
      flag2: 0,
      flag3: 0,
      tipMask: false
    };
  },
  methods: {
    hover(index) {
      switch (index) {
        case 0:
          this.flag0 = 1;
          break;
        case 1:
          this.flag1 = 1;
          break;
        case 2:
          this.flag2 = 1;
          break;
        case 3:
          this.flag3 = 1;
          break;
      }
    },
    out(index) {
      switch (index) {
        case 0:
          this.flag0 = 0;
          break;
        case 1:
          this.flag1 = 0;
          break;
        case 2:
          this.flag2 = 0;
          break;
        case 3:
          this.flag3 = 0;
          break;
      }
    },
    downloadMac() {
      console.log(8888)
        window.location.href =
          "https://ding-talk-platform.bellecdn.cn/download/mac/LarkPlus_20191219-2014-4.7.20-1615.dmg";
      },
      downloadWin(){
        console.log(9999)
    window.location.href =
        "https://ding-talk-platform.bellecdn.cn/download/windows/DingTalk_v4.7.25.50011.exe";
  }
    },
  mounted() {
    var isWweixin = (function() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    })();
    window.onload = function() {
      var winHeight =
        typeof window.innerHeight !== "undefined"
          ? window.innerHeight
          : document.documentElement.clientHeight; // 兼容IOS，不需要的可以去掉
      console.log(winHeight);
      if (isWweixin) {
        this.tipMask = true;
        return false;
      } else {
        this.tipMask = false;
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin: 0px 40px;
  position: relative;
  .logo {
    width: 100px;
    img {
      position: absolute;
      top: 24px;
      left: 0px;
    }
  }
  .banner {
    height: 380px;
    img {
      position: absolute;
      left: 0px;
      top: 80px;
      width: 100%;
      height: 380px;
    }
  }
  .title {
    width: 128px;
    height: 45px;
    margin: 68px 0px 38px 0px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    top: 79px;
  }
  .downLoadWay {
    width: 924px;
    height: 215px;
    display: flex;
    flex-direction: row;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    top: 79px;
    .download {
      width: 204px;
      height: 215px;
      background: rgba(240, 240, 240, 1);
      margin: 0px 18px 174px 18px;
    }
    .android1 {
      position: relative;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 29px;
      }
    }
    .android2 {
      position: relative;
      cursor: pointer;
      img {
        width: 108px;
        height: 108px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 18px;
      }
    }
    .iphone1 {
      position: relative;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 21px;
      }
    }
    .iphone2 {
      position: relative;
      cursor: pointer;
      img {
        width: 108px;
        height: 108px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 18px;
      }
    }
    .mac1 {
      position: relative;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 28px;
      }
    }
    .mac2 {
      position: relative;
      cursor: pointer;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -110px;
      }
    }
    .windows1 {
      position: relative;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 35px;
      }
    }
    .windows2 {
      position: relative;
      cursor: pointer;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -110px;
      }
    }
    .nameWay {
      width: 95px;
      height: 21px;
      font-size: 18px;
      font-family: Helvetica;
      color: rgba(153, 153, 153, 1);
      line-height: 22px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 125px;
    }
    .nameWay1 {
      width: 129px;
      font-size: 14px;
      font-family: Helvetica;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 118px;
    }
    .nameWay2 {
      width: 157px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 130px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/download.vue